export const specialDecoTechniqueCategoryId = '5415';
